import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=0edbea84&"
import script from "./jump.vue?vue&type=script&lang=js&"
export * from "./jump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports